import { Link } from "react-router-dom";
import LegalDocument from "../components/LegalDocument";

export default function Terms() {
  return (
    <LegalDocument title="Terms of service">
      <p className="legal-body__meta">
        Last updated: March 30, 2026. These terms are generic boilerplate—replace with counsel-reviewed
        text before production use.
      </p>

      <h2>Agreement</h2>
      <p>
        By accessing or using HAB LOG (“the Service”), you agree to these Terms of Service. If you do
        not agree, do not use the Service.
      </p>

      <h2>Description of service</h2>
      <p>
        The Service provides tools to record, store, process, and search personal media and related
        metadata. Features may change; we do not guarantee uninterrupted or error-free operation.
      </p>

      <h2>Accounts</h2>
      <p>
        You are responsible for safeguarding your account credentials and for all activity under your
        account. You must provide accurate registration information. You must be at least the age of
        majority in your jurisdiction to use the Service, or have verifiable parental consent where
        required.
      </p>

      <h2>Your content</h2>
      <p>
        You retain rights to content you submit. You grant the Service a limited license to host,
        process, transmit, and display your content solely to operate and improve the Service as
        described in our <Link to="/privacy">Privacy Policy</Link>.
      </p>

      <h2>Acceptable use</h2>
      <p>
        You may not use the Service unlawfully, to infringe others’ rights, to distribute malware, to
        harass, or to overload or circumvent security or rate limits. We may suspend or terminate
        access for violations.
      </p>

      <h2>Disclaimers</h2>
      <p>
        THE SERVICE IS PROVIDED “AS IS” AND “AS AVAILABLE,” WITHOUT WARRANTIES OF ANY KIND, WHETHER
        EXPRESS OR IMPLIED, INCLUDING MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND
        NON-INFRINGEMENT, TO THE MAXIMUM EXTENT PERMITTED BY LAW.
      </p>

      <h2>Limitation of liability</h2>
      <p>
        TO THE MAXIMUM EXTENT PERMITTED BY LAW, HAB LOG AND ITS OPERATORS SHALL NOT BE LIABLE FOR ANY
        INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES, OR ANY LOSS OF PROFITS, DATA,
        OR GOODWILL, ARISING FROM YOUR USE OF THE SERVICE. OUR AGGREGATE LIABILITY SHALL NOT EXCEED THE
        GREATER OF AMOUNTS YOU PAID US IN THE TWELVE MONTHS PRECEDING THE CLAIM OR ONE HUNDRED U.S.
        DOLLARS (IF NO FEES APPLIED).
      </p>

      <h2>Termination</h2>
      <p>
        You may stop using the Service at any time. We may suspend or terminate access for breach of
        these terms, legal requirements, or operational reasons, with or without notice where
        permitted by law.
      </p>

      <h2>Changes</h2>
      <p>
        We may modify these terms. We will post updated terms with a new “Last updated” date.
        Continued use after changes constitutes acceptance. Material changes may require additional
        notice where required by law.
      </p>

      <h2>Governing law</h2>
      <p>
        These terms are governed by the laws of your operator’s jurisdiction, without regard to
        conflict-of-law rules. Courts in that jurisdiction shall have exclusive venue, except where
        prohibited by law.
      </p>

      <h2>Contact</h2>
      <p>
        For questions about these terms, contact the operator at the support email published in the
        application or on the operator’s website.
      </p>
    </LegalDocument>
  );
}
